export default "__VITE_ASSET__s2pWSjz6__"